import { useQuery } from '@tanstack/react-query';
import { strapiListSurveyTeamsForSchedule, type SurveyTeamsScheduleListOptions } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useSurveyTeamsScheduleQuery(
  jwt: string | null,
  options: SurveyTeamsScheduleListOptions = {},
) {
  const userNumericId = options.userNumericId ?? null;
  return useQuery({
    queryKey: queryKeys.surveyTeamsSchedule(jwt, userNumericId),
    queryFn: () => strapiListSurveyTeamsForSchedule(jwt!, options),
    enabled: Boolean(jwt),
  });
}
